import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { error } = await supabase.auth.signInWithPassword({
      email: email,
      password: password,
    });

    if (error) {
      setError(error.message);
    } else {
      navigate('/dashboard', {replace: true});
    }
    setLoading(false);
  };

  return (
    <section className="section is-fullheight has-background-light">
      <div className="container">
            <div className="box p-5" style={{width: '400px', margin: 'auto'}}>
              <h1 className="title has-text-centered mb-5">Log In</h1>
              {error && (
                <div className="notification is-danger">
                  <button className="delete" onClick={() => setError(null)}></button>
                  {error}
                </div>
              )}
              <form onSubmit={handleEmailLogin}>
                <div className="field mb-4">
                  <label className="label" htmlFor="email-login">Email</label>
                  <div className="control has-icons-left">
                    <input
                      className="input"
                      type="email"
                      id="email-login"
                      placeholder="e.g. alex@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={loading}
                      required
                    />
                    <span className="icon is-small is-left">
                      <i className="fas fa-envelope"></i>
                    </span>
                  </div>
                </div>

                <div className="field mb-4">
                  <label className="label" htmlFor="password-login">Password</label>
                  <div className="control has-icons-left">
                    <input
                      className="input"
                      type="password"
                      id="password-login"
                      placeholder="********"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      disabled={loading}
                      required
                    />
                    <span className="icon is-small is-left">
                      <i className="fas fa-lock"></i>
                    </span>
                  </div>
                </div>

                <div className="field">
                  <div className="is-flex is-justify-content-space-between">
                    <label className="checkbox is-flex is-vcentered">
                      <input type="checkbox" className="mr-2" disabled={loading} />
                      Remember me
                    </label>
                    <Link to="/forgot-password">Forgot password?</Link>
                  </div>
                </div>

                <div className="field mt-5">
                  <button
                    className={`button is-link is-fullwidth ${loading ? 'is-loading' : ''}`}
                    type="submit"
                    disabled={loading}
                  >
                    <span className="icon is-small is-left">
                      <i className="fas fa-right-to-bracket"></i>
                    </span>
                    <span>Sing In</span>
                  </button>
                </div>
              </form>

              <p className="has-text-centered mt-5">
                Don't have an account? <Link to="/signup">Sign Up</Link>
              </p>
            </div>
          </div>
    </section>
  );
};

export default LoginPage;